module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('steps', {
    attrs: {
      "currentStep": _vm.currentStep
    },
    on: {
      "switchStep": _vm.switchStep
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "new-product"
  }, [_c('div', {
    staticClass: "my-4"
  }, [(_vm.step === _vm.currentStep) ? _c('div', [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.switchStep.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-end align-items-center border-bottom-light my-4 p-4"
  }, [_c('button', {
    staticClass: "btn blue wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.prevStep
    }
  }, [_c('i', {
    staticClass: "ico-arrow-left fs-normal ml-2"
  }), _vm._v(" Back")]), _vm._v(" "), _c('button', {
    staticClass: "btn cancel wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.getSelectedItem !== null) ? _c('button', {
    staticClass: "btn green wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.readyToSave
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn blue wider",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("Next "), _c('i', {
    staticClass: "ico-arrow-right fs-normal ml-2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "px-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [(_vm.resources == undefined) ? _c('div', {
    staticClass: "text-center dark"
  }, [_c('div', [_vm._v("Loading resources please wait")])]) : _vm._e(), _vm._v(" "), [(_vm.resources && _vm.resources !== undefined && _vm.resources.length > 0) ? _c('div', {
    staticClass: "panel shaded"
  }, [_c('h5', {
    staticClass: "border-bottom-lightest"
  }, [_vm._v("What are the available resources for this product?")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('table', {
    staticClass: "table narrow"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.form.resources), function(resource, index) {
    return _c('tr', [_c('td', {
      staticClass: "p-3"
    }, [_c('v-select', {
      attrs: {
        "options": _vm.resources,
        "placeholder": "- Select resource -",
        "label": "name"
      },
      on: {
        "input": function($event) {
          return _vm.updateResourcesList(resource, index)
        }
      },
      model: {
        value: (_vm.form.resources[index]),
        callback: function($$v) {
          _vm.$set(_vm.form.resources, index, $$v)
        },
        expression: "form.resources[index]"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "pl-3"
    }, [_vm._v("\n                                                                " + _vm._s(_vm.fetchCapacity(resource)) + "\n                                                            ")]), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "ico-delete largest medium pointer",
      on: {
        "click": function($event) {
          return _vm.deleteRow(index, 'resources')
        }
      }
    })])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "add d-flex align-items-center pointer fs-small bold mt-5",
    on: {
      "click": _vm.addResource
    }
  }, [_c('i', {
    staticClass: "ico-add fs-smallest add-circle color-1"
  }), _vm._v(" Add new\n                                                ")])])])]) : _vm._e(), _vm._v(" "), (_vm.resources && _vm.resources.length == 0) ? _c('div', {
    staticClass: "text-center dark"
  }, [_c('div', [_vm._v("Looks like you have no resources in your inventory :(")]), _vm._v(" "), _c('button', {
    staticClass: "btn mt-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.createResource
    }
  }, [_vm._v("Create Resource")])]) : _vm._e()]], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end align-items-center border-bottom-light my-4 p-4"
  }, [_c('button', {
    staticClass: "btn blue wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.prevStep
    }
  }, [_c('i', {
    staticClass: "ico-arrow-left fs-normal ml-2"
  }), _vm._v(" Back")]), _vm._v(" "), _c('button', {
    staticClass: "btn cancel wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.getSelectedItem !== null) ? _c('button', {
    staticClass: "btn green wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.readyToSave
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn blue wider",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("Next "), _c('i', {
    staticClass: "ico-arrow-right fs-normal ml-2"
  })])])])]) : _vm._e()])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "pl-3"
  }, [_vm._v("Resource")]), _vm._v(" "), _c('th', {
    staticClass: "pl-3"
  }, [_vm._v("Capacity limit")]), _vm._v(" "), _c('th', {
    staticClass: "pl-3"
  }, [_vm._v(" ")]), _vm._v(" "), _c('th', {
    staticClass: "pl-3"
  }, [_vm._v(" ")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-0ca39ac8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ca39ac8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/products/ProductResources.vue
// module id = 1650
// module chunks = 0